export default __webpack_public_path__ + "static/media/shoes_erythree.cf9977bc.svg";